import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { url } from '../../Config';

const Tests = () => {
  const [tests, setTests] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${url}/api/tests`)
      .then(res => res.json())
      .then(setTests)
      .catch(err => console.error('Error loading tests:', err));
  }, []);

  const openTestPreview = async (slug) => {
    const res = await fetch(`${url}/api/test/${slug}`);
    if (!res.ok) return alert('Test not found!');
    const test = await res.json();
    setSelectedTest({ ...test, slug });
  };

  const startTest = () => {
    navigate(`/test/${selectedTest.slug}`); // ✅ navigate with slug in URL
  };

return (
  <div className="flex justify-center items-start min-h-screen bg-gradient-to-r from-white via-[#E6F0FF] to-[#BFD7FF] p-8">
    {!selectedTest ? (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {tests.map(test => (
          <div
            key={test.slug}
            onClick={() => openTestPreview(test.slug)}
            className="bg-white/90 rounded-2xl shadow-lg p-6 cursor-pointer hover:scale-105 hover:shadow-xl transition-transform duration-300 flex flex-col justify-between"
          >
            <div>
              <h3 className="text-xl font-bold text-blue-900">{test.testName}</h3>
              <p className="text-sm text-blue-700 mt-1">
                By <span className="font-semibold">{test.authorId.username || 'Unknown'}</span>
              </p>
              {test.testTimeLimit && (
                <p className="text-sm text-blue-600 mt-2">
                  ⏱ {test.testTimeLimit} minute{parseInt(test.testTimeLimit) > 1 ? 's' : ''}
                </p>
              )}
              <p className="text-xs text-blue-400 mt-2">
                Created on {new Date(test.createdAt).toLocaleDateString()}
              </p>
            </div>
            <div className="mt-4">
              <span className="bg-blue-100 text-blue-800 text-sm font-semibold px-3 py-1 rounded-full shadow">
                Free
              </span>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="bg-white/90 shadow-2xl p-8 rounded-3xl w-full max-w-4xl mx-auto animate-fadeIn border border-blue-100">
        {/* Title & Author */}
        <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center mb-6">
          <h2 className="text-4xl font-extrabold text-blue-900 mb-3 md:mb-0">
            {selectedTest.testName}
          </h2>
          <div className="text-blue-700 text-sm md:text-base">
            <span className="font-semibold">By:</span> {selectedTest.authorName || 'Unknown'}
          </div>
        </div>

        {/* Test Image */}
        {selectedTest.testImage && (
          <div className="mb-6 flex justify-center">
            <img
              src={selectedTest.testImage}
              alt={selectedTest.testName}
              className="w-full max-w-md rounded-xl shadow-lg object-cover"
            />
          </div>
        )}

        {/* Description */}
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-5 shadow-sm mb-6">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">Description</h3>
          <p className="text-blue-900 whitespace-pre-wrap">
            {selectedTest.testDescription || 'No description provided.'}
          </p>
        </div>

        {/* Instructions */}
        <div className="bg-blue-100 border border-blue-300 rounded-xl p-5 shadow-md mb-6">
          <h3 className="text-xl font-semibold text-blue-900 mb-2">Instructions</h3>
          <p className="text-blue-800 whitespace-pre-wrap">
            {selectedTest.testInstructions || 'No instructions provided.'}
          </p>
        </div>

        {/* Time Limit */}
        {selectedTest.testTimeLimit && (
          <p className="text-blue-700 mb-6 text-sm">
            <strong>Time Limit:</strong> {selectedTest.testTimeLimit} minute
            {parseInt(selectedTest.testTimeLimit) > 1 ? 's' : ''}
          </p>
        )}

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-6">
          <button
            onClick={() => setSelectedTest(null)}
            className="px-6 py-3 rounded-2xl bg-blue-200 hover:bg-blue-300 text-blue-800 font-semibold transition-all shadow-sm"
          >
            ← Back
          </button>
          <button
            onClick={startTest}
            className="px-8 py-3 rounded-2xl bg-blue-600 text-white font-bold hover:bg-blue-700 transition-all shadow-lg"
          >
            Start Test
          </button>
        </div>

        {/* Alert: Result Shared */}
        <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-xl shadow-md flex items-center gap-3">
          <svg
            className="w-6 h-6 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm md:text-base font-medium">
            ⚠️ Your result will be shared with the test owner.
          </p>
        </div>
      </div>
    )}
  </div>
);

};

export default Tests;
